import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

function PrayerDevotion({ config }) {
  const [prayers, setPrayers] = useState([]);
  const [entry, setEntry] = useState("");
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.get("/me/prayer-list").then(({ data }) => setPrayers(data.prayers.slice(0, 3))).catch(() => {});
  }, []);

  const save = async () => {
    if (!entry.trim()) return;
    await api.post("/me/journal", { entry, period: config.period });
    setSaved(true);
    setEntry("");
    toast(config.savedToast);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div className="max-w-2xl mx-auto px-6 md:px-10 py-24">
      <div className="text-center animate-fade-in">
        <p className="mono-label mb-8">{config.label}</p>
        {config.opening.map((line, i) => (
          <p key={i} className={`font-heading ${i === 0 ? "text-4xl md:text-5xl text-ink" : "text-xl md:text-2xl text-ink-secondary italic"} leading-snug ${i > 0 ? "mt-5" : ""}`}>
            {line}
          </p>
        ))}
      </div>

      {prayers.length > 0 && (
        <div className="my-16 paper-rule pt-12">
          <p className="mono-label text-center mb-8">{config.listLabel}</p>
          <div className="space-y-8">
            {prayers.map((p) => (
              <div key={p.id} className="text-center" data-testid={`devotion-prayer-${p.id}`}>
                <h3 className="font-heading text-2xl text-ink">{p.display_name}</h3>
                <p className="font-body text-ink-secondary mt-1 leading-relaxed">{p.excerpt}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="text-center paper-rule pt-12">
        {config.closing.map((line, i) => (
          <p key={i} className="font-heading italic text-xl md:text-2xl text-ink leading-snug mt-4">{line}</p>
        ))}
        <p className="font-heading italic text-2xl md:text-3xl text-terracotta mt-8 leading-snug">
          May my life today become an answer to someone's prayer.
        </p>
        <p className="font-heading text-2xl text-ink mt-6">Amen.</p>
      </div>

      <div className="mt-20">
        <label className="block">
          <span className="font-heading text-2xl md:text-3xl text-ink block text-center mb-6">{config.promptQuestion}</span>
          <textarea
            rows={3}
            value={entry}
            onChange={(e) => setEntry(e.target.value)}
            placeholder={config.placeholder}
            className="w-full bg-transparent border border-ink/25 px-4 py-3 font-body text-lg text-ink focus:border-ink outline-none"
            data-testid="journal-entry"
          />
        </label>
        <button onClick={save} className="btn-solid w-full mt-5" data-testid="journal-save">{config.saveLabel}</button>
        {saved && <p className="mono-label text-center mt-4">{config.savedInline}</p>}
        <p className="font-body text-sm text-ink-tertiary text-center mt-6 italic">Kept privately in your own journal. Never published.</p>
      </div>
    </div>
  );
}

export function MorningPrayer() {
  return (
    <PrayerDevotion config={{
      period: "morning", label: "Morning Prayer",
      opening: ["Here I am.", "May I be still enough to hear.", "May I see clearly what is before me.", "May those whose prayers I carry be held in love.", "May I not insist upon the answer, but become willing to receive what is given."],
      listLabel: "Those I am carrying today",
      closing: ["May I recognise what has already been given."],
      promptQuestion: "How might I serve today?",
      placeholder: "A private intention for the day…",
      saveLabel: "Keep this privately", savedInline: "Kept.", savedToast: "Gratitude registered.",
    }} />
  );
}

export function EveningPrayer() {
  return (
    <PrayerDevotion config={{
      period: "evening", label: "Evening Prayer",
      opening: ["For this day, thank you.", "For what I understood and what I did not understand.", "For what was given and what was withheld.", "For those I remembered and those who remembered me."],
      listLabel: "Those I carried today",
      closing: [
        "Where I could have loved and did not, let me see more clearly tomorrow.",
        "Where something I once asked for has quietly been given, let me recognise it.",
        "What remains unresolved, I release for tonight.",
      ],
      promptQuestion: "What was given today?",
      placeholder: "A sentence of gratitude…",
      saveLabel: "Save to my gratitude journal", savedInline: "Gratitude registered.", savedToast: "Gratitude registered.",
    }} />
  );
}
